<div class="modal-dialog fade backdrop" tabindex="-1" [class]="class">
    <div class="card" [class]="additionalClass" (clickOutside)="closeClickOutside()" [ngClass]="isWarning ? 'warning' : ''">
        <header>
            <h2 *ngIf="options && options.headline" [innerHtml]="options.headline"></h2>
            <a class="close-icon" (click)="close()"><i class="drg-icon-close"></i></a>
        </header>
        <section *ngIf="template" [ngClass]="isCookie ? 'cookie-section' : ''">
            <ng-container *ngTemplateOutlet="template; context: { invalid: hasError }"> </ng-container>
        </section>
    </div>
</div>
